import { createContext, useContext } from 'react';
import type {
  OnboardingData,
  EnglishComfortLevel,
  ConcernType,
} from '@/types/profile';

export const TOTAL_ONBOARDING_STEPS = 7;

export interface QuickWinResult {
  correct: boolean;
  transcript: string;
}

export interface OnboardingState extends OnboardingData {
  currentStep: number;
  quickWinResult: QuickWinResult | null;
}

export interface OnboardingContextType {
  state: OnboardingState;
  setName: (name: string) => void;
  setInterviewDate: (date: string | null) => void;
  setEnglishLevel: (level: EnglishComfortLevel) => void;
  setConcerns: (concerns: ConcernType[]) => void;
  toggleConcern: (concern: ConcernType) => void;
  setStep: (step: number) => void;
  setQuickWinResult: (result: QuickWinResult) => void;
  reset: () => void;
}

export const OnboardingContext = createContext<OnboardingContextType | undefined>(
  undefined
);

export function useOnboardingContext() {
  const context = useContext(OnboardingContext);
  if (context === undefined)
    throw new Error(
      'useOnboardingContext must be used within an OnboardingProvider'
    );
  return context;
}
